"use client";

import React, { useEffect, useState } from "react";
import HardDeadlineModal from "./Modal/hardDeadline";
import useProfileStore from "@/store/useProfileStore";
import { SubscriptionStatus } from "@/constants/subscriptionStatus";
import StripePaymentMethodModal from "./billing/stripePaymentMethodModal";
import { useQueryClient } from "@tanstack/react-query";

const SubscriptionModalWrapper: React.FC = () => {
  const { profileData } = useProfileStore();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [showPaymentModal, setShowPaymentModal] = useState<boolean>(false);
  const queryClient = useQueryClient();

  const hardDeadlineStatus = SubscriptionStatus.POSTHARDDEADLINE;

  useEffect(() => {
    // Check if subscription status is inactive
    if (profileData?.subscription_status === hardDeadlineStatus) {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  }, [profileData?.subscription_status]);

  const handleCloseModal = () => {
    // Don't allow closing the modal when subscription is inactive
    // The modal should remain open until payment is processed
    if (profileData?.subscription_status === hardDeadlineStatus) {
      return;
    }
    setIsModalOpen(false);
  };

  const handleProceedToPayment = () => {
    setShowPaymentModal(true);
  };

  const handlePaymentSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ["profile"] });
    setIsModalOpen(false);
  };

  // Only render the modal if subscription is inactive
  if (profileData?.subscription_status !== hardDeadlineStatus) {
    return null;
  }

  return (
    <>
      <HardDeadlineModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onProceedToPayment={handleProceedToPayment}
        preventClose={true}
      />

      {/* Payment Method Modal */}
      {showPaymentModal && (
        <StripePaymentMethodModal
          open={showPaymentModal}
          setOpen={setShowPaymentModal}
          onSuccess={handlePaymentSuccess}
        />
      )}
    </>
  );
};

export default SubscriptionModalWrapper;
